<template>
  <div class="app">
    <h1>微信公众号授权登录</h1>
    <button @click="redirectToWeChatLogin">微信授权登录</button>
    <div v-if="userInfo">
      <h2>用户信息</h2>
      <p>昵称: {{ userInfo.nickname }}</p>
      <p>头像: <img :src="userInfo.headimgurl" alt="头像" /></p>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      userInfo: null, // 存储用户信息
      appId: "wx9b149fc008c36547", // 公众号的 AppID
      appSecret: "5cb8fb6afced5d509f9241d7defd81d9", // 公众号的 AppSecret
      redirectUri: "https://xjsofjk.cn/wechat/login", // 设置回调地址
      //http://localhost:8081/wechat/login
      //?appid=ovjT66is3jtGXRL2MhTIdet_I69c
      //?code=061JXbml2er66f4AAwol2YIUhi0JXbm5&state=123
    };
  },
  methods: {
    // 引导用户到微信授权页面
    redirectToWeChatLogin() {
      const redirectUrl = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${this.appId}&redirect_uri=${encodeURIComponent(this.redirectUri)}&response_type=code&scope=snsapi_userinfo&state=123#wechat_redirect`;
      window.location.href = redirectUrl;
    },

    // 获取用户信息
    async getUserInfo(code) {
      try {
        // 使用 code 获取 access_token
        const response = await axios.get(
            `https://api.weixin.qq.com/sns/oauth2/access_token?appid=${this.appId}&secret=${this.appSecret}&code=${code}&grant_type=authorization_code`
        );

        const { access_token, openid } = response.data;

        // 使用 access_token 获取用户信息
        const userInfoResponse = await axios.get(
            `https://api.weixin.qq.com/sns/userinfo?access_token=${access_token}&openid=${openid}&lang=zh_CN`
        );

        /**
         * {
         *   "openid": "OPENID",
         *   "nickname": NICKNAME,
         *   "sex": 1,
         *   "province":"PROVINCE",
         *   "city":"CITY",
         *   "country":"COUNTRY",
         *   "headimgurl":"https://thirdwx.qlogo.cn/mmopen/g3MonUZtNHkdmzicIlibx6iaFqAc56vxLSUfpb6n5WKSYVY0ChQKkiaJSgQ1dZuTOgvLLrhJbERQQ4eMsv84eavHiaiceqxibJxCfHe/46",
         *   "privilege":[ "PRIVILEGE1" "PRIVILEGE2"     ],
         *   "unionid": "o6_bmasdasdsad6_2sgVt7hMZOPfL"
         * }
         */
        this.userInfo = userInfoResponse.data;
        this.$Message.error('必填项有为空，请把为空的填上! {}', this.userInfo);
      } catch (error) {
        console.error("获取用户信息失败", error);
      }
    },
  },
  created() {
    // 获取微信授权回调的 code 参数
    const urlParams = new URLSearchParams(window.location.search);
    const code = urlParams.get("code");

    // 如果有 code，说明是从微信回调过来的，开始获取用户信息
    if (code) {
      this.getUserInfo(code);
    }
  },
};
</script>

<style scoped>
/* 页面样式 */
.app {
  text-align: center;
  margin-top: 50px;
}

button {
  padding: 10px 20px;
  font-size: 16px;
  background-color: #1aad19;
  color: white;
  border: none;
  border-radius: 5px;
}

h2 {
  margin-top: 20px;
}
</style>
